import React from "react";
import { TouchableOpacity } from "react-native";
import { View } from "react-native-animatable";
import Icon from "../../icon/Icon";
import Typography from "../../typography/Typography";
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from "@voltmoney/schema";
const AboutUsScreenContent = ({ icon, label, action, triggerAction, }) => {
    return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, onPress: async () => {
            if (action) {
                await triggerAction(action);
            }
        } },
        React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(Icon, { name: icon, size: IconSizeTokens.LG, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginLeft: 10 } },
                React.createElement(Typography, { label: label, typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night }))),
        React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })));
};
export default AboutUsScreenContent;
